export const packList = [
"swdbg_2v2.json",
"swdbg_solo_leaders_empire.json",
"swdbg_solo_leaders_rebel.json",
"swdbg_standard.json",
"swdbg_standard_clone_wars.json",
];